import toast from "react-hot-toast";
import axiosSetup from "../utils/axiosSetup";
import { IUpdateB2BPrice } from "../models/productData.model";

export const fetchAllProductsAndRawMaterials = async (params: any) => {
  try {
    const response = await axiosSetup.get(
      "/priceList/get-all-products-and-raw-materials-margin",
      { params },
    );
    return response?.data?.data;
  } catch (error) {
    console.error("Failed to fetch products:", error);
    return toast.error("Failed to fetch products");
  }
};

export const updateB2BPriceApi = async (payload: IUpdateB2BPrice) => {
  try {
    const response = await axiosSetup.put(
      "/priceList/update-b2b-price",
      {
        type: payload.type,
        b2bPrice: payload.b2bPrice,
        b2bMargin: payload.b2bMargin,
      },
      {
        params: { _id: payload._id },
      },
    );

    return response.data.data;
  } catch (error) {
    console.error("Update failed:", error);
    toast.error("Failed to update price");
    throw error;
  }
};

export const fetchBOMPriceList = async (params: any) => {
  try {
    const response = await axiosSetup.get("/priceList/get-bom-price-list", {
      params,
    });
    return response?.data?.data;
  } catch (error) {
    console.error("Failed to fetch BOM price list:", error);
    return toast.error("Failed to fetch BOM price list");
  }
};